import { render, staticRenderFns } from "./DateFormatInputs.vue?vue&type=template&id=18cec6a0&"
import script from "./DateFormatInputs.vue?vue&type=script&lang=ts&"
export * from "./DateFormatInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports